import React, { useState,useEffect } from "react";
import { useStoreDispatch, APP_STORE_ACTION,useStoreState } from '../../../../common/storeContext';
import { Row, Col, Form } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import Title from '../../../pageTitle/default.js';
import { useForm } from "react-hook-form";
import Alert from '../../../../components/Alert';
import { useMiddletier } from "../../../../common/middletier";
import Loading from '../../../../components/Loading';
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
    const appDispatch = useStoreDispatch()
    const appState = useStoreState()

    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const { mutation } = useMiddletier()
    const navigate = useNavigate();


    const {
        register: change_password,
        getValues,
        formState: { errors, isValid },
        handleSubmit,
        reset,
    } = useForm({
        mode: "onChange",
    });

    const onSubmit = (data) => {
        setLoading(true)
        const method = 'changePasswordByAffiliate'

        mutation([{
            method,
            params: [
                { code: 'oldPassword', graphqlType: 'String', required: true, value: data.current_password },
                { code: 'newPassword', graphqlType: 'String', required: true, value: data.new_password },
            ],
            attributes: []

        }])
            .then(({ data }) => {
                setLoading(false)
                appDispatch({
                    type: APP_STORE_ACTION.SHOW_ALERT,
                    payload: { description: 'Change Password Successful', typeAlert: 'success' }
                });
            })
            .catch((error) => {
                setLoading(false)
                console.log('error: ', error)
                if (error?.networkError?.statusCode === 401) {
                    appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
                } else {
                    appDispatch({
                        type: APP_STORE_ACTION.SHOW_ALERT,
                        payload: { description: error.message.toString(), typeAlert: 'error' }
                    });
                }
            })
        reset()

    };



    return (
        <>
            <Form className="changePassword_form" onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="form_input_wrap" >
                    <div className="input_wrap">
                        <Form.Label>{t('current_password')}
                            <span className="form_required_input">* {t('required_fill_in')}</span>
                        </Form.Label>
                        <Form.Control
                            type="password"
                            // placeholder={t('current_password')}
                            className=" input_changePassword_currentPassword"
                            aria-label="changePassword_currentPassword"
                            onKeyDown={(event) => {
                                if (event.key === ' ') {
                                    event.preventDefault();
                                }
                            }}
                            onInput={(event) => {
                                if (event.target.value.includes(' ')) {
                                    event.target.value = event.target.value.replace(/ /g, '');
                                }
                            }}
                            {...change_password("current_password", { required: t('error_password_empty'), minLength: { value: 6, message: t('error_password_length') } })}

                        />
                        <p className="input_error_msg">{errors.current_password?.message}</p>
                    </div>
                </Form.Group>
                <Form.Group className="form_input_wrap" >
                    <div className="input_wrap">
                        <Form.Label>{t('new_password')}
                            <span className="form_required_input">* {t('required_fill_in')}</span>
                        </Form.Label>
                        <Form.Control
                            type="password"
                            // placeholder={t('new_password')}
                            className=" input_changePassword_newPassword"
                            aria-label="changePassword_newPassword"
                            onKeyDown={(event) => {
                                if (event.key === ' ') {
                                    event.preventDefault();
                                }
                            }}
                            onInput={(event) => {
                                if (event.target.value.includes(' ')) {
                                    event.target.value = event.target.value.replace(/ /g, '');
                                }
                            }}
                            {...change_password("new_password", {
                                required: t('error_password_empty'), minLength: { value: 6, message: t('error_password_length') }, validate: (value) => {
                                    const { current_password } = getValues();
                                    return current_password !== value || 'New Password Cannot Same As Current Password';
                                }
                            })}
                        />
                        <p className="input_error_msg">{errors.new_password?.message}</p>
                    </div>
                </Form.Group>
                <Form.Group className="form_input_wrap" >
                    <div className="input_wrap">
                        <Form.Label>{t('confirm_password')}
                            <span className="form_required_input">* {t('required_fill_in')}</span>
                        </Form.Label>
                        <Form.Control
                            type="password"
                            // placeholder={t('confirm_password')}
                            className=" input_changePassword_confirmPassword"
                            aria-label="changePassword_confirmPassword"
                            onKeyDown={(event) => {
                                if (event.key === ' ') {
                                    event.preventDefault();
                                }
                            }}
                            onInput={(event) => {
                                if (event.target.value.includes(' ')) {
                                    event.target.value = event.target.value.replace(/ /g, '');
                                }
                            }}
                            {...change_password("confirm_password", {
                                required: true, minLength: { value: 6 }, validate: (value) => {
                                    const { new_password } = getValues();
                                    return new_password === value || t('error_confirm_password_matchPassword');
                                }
                            })}
                        />
                        <p className="input_error_msg">{errors.confirm_password?.message}</p>
                    </div>
                </Form.Group>
                <input className="font_button color_button wallet_btnSubmit" type="submit" value={t('submit')} disabled={!isValid} />
            </Form>

            {isLoading && (<Loading />)}
        </>
    );
};


const ChangePasswordBody = () => {

    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 992px)'
    })

    return (
        <>
            <div className="changePassword_body">
                {isDesktopOrLaptop ? <>
                    <div className="wallet_container_wrap">
                        <Row>
                            <Col lg={7} >
                                <ChangePassword />
                            </Col>
                        </Row>
                    </div>
                </> : <>
                    <Title title={"change_password"} desktopToggle={false} mobileToggle={true} id={'changePassword_title'} />
                    <div className="myAccount_wrap">
                        <ChangePassword />
                    </div>
                </>}
            </div>
        </>

    );




};






export default ChangePasswordBody;
